import { DI_CONTAINER } from '@integration-frontends/core';
import { useDependencyInjector } from '@integration-frontends/core/di-container/react';
import {
  Asset,
  Attachment,
  IMediaTypeSupportService,
  MEDIA_TYPE_SUPPORT_SERVICE_TOKEN,
} from '@integration-frontends/integration/core/model';
import React from 'react';
import { AttachmentDragAndDrop } from '../../../../common/attachment-drag-and-drop';
import { AttachmentThumbnailImage } from '../../../../common/attachment-thumbnail-image';
import {
  ATTACHMENT_SELECTOR_FEATURES_TOKEN,
  AttachmentSelectorFeature,
  IAttachmentSelectorFeaturesService,
} from '../../../../features';
import { Thumbnail } from '../../../common/thumbnail';

export interface AttachmentThumbnailProps {
  asset: Asset;
  attachment: Attachment;
  selected: boolean;
}

export function AttachmentThumbnail({ asset, attachment, selected }: AttachmentThumbnailProps) {
  const featureService: IAttachmentSelectorFeaturesService = useDependencyInjector(
    ATTACHMENT_SELECTOR_FEATURES_TOKEN,
  );

  const mediaTypeSupportService = DI_CONTAINER.get<IMediaTypeSupportService>(
    MEDIA_TYPE_SUPPORT_SERVICE_TOKEN,
  );

  const thumbnail = (
    <Thumbnail
      role="img"
      aria-label="Thumbnail image preview of asset"
      selected={selected}
      className="h-full w-full"
    >
      <AttachmentThumbnailImage
        draggable={false}
        alt="Thumbnail preview of attachment"
        attachment={attachment}
      />
    </Thumbnail>
  );

  const containerStyle = { flex: '0 0 100px', height: 80 };
  return featureService.hasFeature(AttachmentSelectorFeature.DragAndDrop) &&
    mediaTypeSupportService.isSupported(attachment?.mediaType) &&
    asset.availability !== 'view_only' ? (
    <AttachmentDragAndDrop attachment={attachment} style={containerStyle}>
      {thumbnail}
    </AttachmentDragAndDrop>
  ) : (
    <div style={containerStyle}>{thumbnail}</div>
  );
}
